import * as DOM from "../services/dom";
import {Component} from "./component";

export class Like extends Component {

    setup() {
        this.elem = this.$el;
        this.entityID = this.$opts.entityId;
        this.entityType = this.$opts.entityType;
        this.paragraphID = this.$opts.paragraphId;
        this.bookSlug = this.$opts.bookSlug;
        this.actionElem = null;
        this.action = null;
        this.countLikes = 0;
        this.countDislikes = 0;

        this.id = this.$opts.likeId;
        this.container = this.$refs.likeContainer;
        // Translations
        this.countLikes = Number(this.$opts.likes);
        this.countDislikes = Number(this.$opts.dislikes);

        this.countTotalLikes = Number(document.getElementById('total_likes').innerText);
        this.countTotalDislikes = Number(document.getElementById('total_dislikes').innerText);

        this.likes = this.container.querySelector('#likes');
        this.dislikes = this.container.querySelector('#dislikes');

        this.isRequestPending = false;

        this.elem.addEventListener('click', this.handleAction.bind(this));
    }

    handleAction(event) {
        this.actionElem = event.target;

        if (this.actionElem === null || this.actionElem.dataset === null) return;
        event.preventDefault();

        this.action = this.actionElem.dataset.action.trim();

        if (this.action === 'unlike' && this.id) this.remove();

        if (this.action === 'like') {
            if(this.id) {
                this.update(1);
            } else {
                this.save(1);
            }
        }

        if (this.action === 'dislike') {
            if (this.id) {
                this.update(-1);
            } else {
                this.save(-1);
            }
        }

        if (this.action === 'login') {
            window.location.href = "/login";
        }
    }

    save(value) {
        event.preventDefault();
        event.stopPropagation();

        if (this.isRequestPending) {
            return;
        }

        this.isRequestPending = true;

        let reqData = {
            entity_id: this.entityID,
            entity_type: this.entityType,
            like: value,
            book_slug: this.bookSlug
        };

        if (this.paragraphID) {
            reqData.paragraph_id = this.paragraphID;
        }
        window.$http.post(`/like`, reqData).then(resp => {
            if (resp.data.success !== false) {
                this.like();
                this.changeCount();
                this.id = resp.data.id;

                this.isRequestPending = false;
            }
        }).catch(err => {
            console.log(error);
        });
    }

    update(value) {
        window.$http.put(`/like/` + this.id, {like: value, book_slug: this.bookSlug}).then(resp => {
            this.unlike(this.container.querySelector('.liked'))
            this.like();
            this.changeCount();
        });
    }

    remove() {
        if (this.isRequestPending) {
            return;
        }

        this.isRequestPending = true;

        window.$http.delete(`/like/` + this.id).then(resp => {
            if (resp.data.success !== false) {
                this.unlike(this.actionElem);
                this.id = null;
                this.changeCount();

                this.isRequestPending = false;
            }
        });
    }

    like() {
        this.actionElem.classList.remove("like");
        this.actionElem.classList.add("liked");
        this.actionElem.dataset.action = "unlike";

        if (this.actionElem.dataset.type === 'like') {
            this.likes.classList.remove("like");
            this.likes.classList.add("liked");
        }

        if (this.actionElem.dataset.type === 'dislike') {
            this.dislikes.classList.remove("like");
            this.dislikes.classList.add("liked");
        }
    }

    unlike(element) {
        element.classList.remove("liked");
        element.classList.add("like");


        if (element.dataset.type === 'like') {
            element.dataset.action = "like";
            this.likes.classList.remove("liked");
            this.likes.classList.add("like");
        }

        if (element.dataset.type === 'dislike') {
            element.dataset.action = "dislike";
            this.dislikes.classList.remove("liked");
            this.dislikes.classList.add("like");
        }
    }

    changeCount() {
        if (this.action === 'like') {
            if (this.id) {
                if (this.countDislikes > 0) {
                    this.countDislikes = this.countDislikes - 1;
                   // this.countTotalDislikes = this.countTotalDislikes - 1;
                }

                this.countLikes = this.countLikes + 1;
                //this.countTotalLikes = this.countTotalLikes + 1;
            } else {
                this.countLikes = this.countLikes + 1;
                //this.countTotalLikes = this.countTotalLikes + 1;
            }
        }

        if (this.action === 'dislike') {
            if (this.id) {
                this.countDislikes = this.countDislikes + 1;
               // this.countTotalDislikes = this.countTotalDislikes + 1;

                if (this.countLikes > 0) {
                    this.countLikes = this.countLikes - 1;
                    //this.countTotalLikes = this.countTotalLikes - 1;
                }
            } else {
                this.countDislikes = this.countDislikes + 1;
                //this.countTotalDislikes = this.countTotalDislikes + 1;
            }
        }

        if (this.action === 'unlike') {
            if (this.actionElem.dataset.type === 'like') {
                this.countLikes = this.countLikes - 1;
                //this.countTotalLikes = this.countTotalLikes - 1;
            }

            if (this.actionElem.dataset.type === 'dislike') {
                this.countDislikes = this.countDislikes - 1;
                //this.countTotalDislikes = this.countTotalDislikes - 1;
            }
        }

        this.likes.innerText = this.countLikes;
        this.dislikes.innerText = this.countDislikes;

        //document.getElementById('total_likes').innerText = this.countTotalLikes;
        //document.getElementById('total_dislikes').innerText = this.countTotalDislikes;
    }
}
